// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportsDropdown-module__root__23XB3","dropdown-width":"ReportsDropdown-module__dropdown-width__1rpeI"};